import * as LocalStorage from './localstorage'

export const isAdmin = () => {
  const userType = LocalStorage.get('currentUser').userType;
  return userType === 'AD' || userType === 'CSC_AD';
}
